"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Entry.FieldLineBreak = /*#__PURE__*/function (_Entry$Field) {
  function FieldLineBreak(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldLineBreak);
    _this = _callSuper(this, FieldLineBreak);
    _this._block = blockView.block;
    _this._blockView = blockView;
    _this._index = index;
    var box = new Entry.BoxModel();
    _this.box = box;
    _this.setValue(null);
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldLineBreak, _Entry$Field);
  return (0, _createClass2["default"])(FieldLineBreak, [{
    key: "renderStart",
    value: function renderStart() {
      return;
    }
  }, {
    key: "align",
    value: function align(targetStatementIndex) {
      var blockView = this._blockView;
      if (blockView._statements.length === 0) {
        return;
      }
      this.box.set({
        y: (blockView._statements[targetStatementIndex].height || 20) + Math.max(blockView.contentHeight % 1000, 30)
      });
    }
  }]);
}(Entry.Field);